/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Patrol_Rounds_LabelInputs */

const en_dispatch_patrol_rounds_label = /** @type {(inputs: Dispatch_Patrol_Rounds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rounds`)
};

const fr_dispatch_patrol_rounds_label = /** @type {(inputs: Dispatch_Patrol_Rounds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tours`)
};

const ms_sg2_dispatch_patrol_rounds_label = /** @type {(inputs: Dispatch_Patrol_Rounds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusingan`)
};

/**
* | output |
* | --- |
* | "Rounds" |
*
* @param {Dispatch_Patrol_Rounds_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_patrol_rounds_label = /** @type {((inputs?: Dispatch_Patrol_Rounds_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Patrol_Rounds_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_patrol_rounds_label(inputs)
	if (locale === "fr") return fr_dispatch_patrol_rounds_label(inputs)
	return ms_sg2_dispatch_patrol_rounds_label(inputs)
});